<div class="questionnaire-title">
    <div *ngIf="title" class="font-large title" [innerHTML]="title"></div>
    <div *ngIf="hint" class="text font-larger" [innerHTML]="hint"></div>
</div>
<textarea
    [ngModel]="answer" (ngModelChange)="onAnswerChange($event)"
    [disabled]="disabled"
    [placeholder]="placeholder || ''
"></textarea>
